import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      className="close-icon"
    >
      <path
        stroke="var(--task-eva-modal-close-icon)"
        strokeWidth="1.33"
        d="M4 4l12 12M16 4L4 16"
      ></path>
    </svg>
  );
}

export default Icon;
